window.onload = () => {
    const contentContainer = document.querySelector('.boldtrailbrand-content');
    if(contentContainer && !window.location.href.includes("overview") ){
        window.scrollTo({
            behavior: 'smooth',
            top: contentContainer.getBoundingClientRect().top - 50
        });
    }
}